import { CaptionedImage } from '@/components/controls';
import { useNichePersonImage, useOptionLookup } from '@/hooks';
import { toProperCase } from '@/utils';

export function CaptionedNichePersonImage({ person }) {
  const personClassifications = useOptionLookup('personClassification');
  const {
    query: { data: imageSrc },
  } = useNichePersonImage(person.id);

  return (
    <CaptionedImage
      imageSrc={imageSrc}
      height={320}
      fallbackWidth={240}
      topCaption={(person.classificationCodes ?? [])
        .map((code) => personClassifications[code] ?? code)
        .join(', ')}
      bottomCaption={toProperCase(
        [person.forenames, person.surname].filter(Boolean).join(' '),
      )}
    />
  );
}
